







import Vue from "vue";
//import SelectForm from "@cm/SelectForm/index.vue";
//import images from "@/utils/images";
export default Vue.extend({
  components: {
    //SelectForm,
  },
  computed: {
    //getImages() {
    //  return images;
    //},
  },
});
